/* NgRx */
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SessionsListState} from './sessions-list.reducer';

// Selector functions
const sessionsListData =
  createFeatureSelector<SessionsListState>('ss-cord.sessions-list');

export const sessionDeliveryFilter = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.sessionDeliveryFilter
);

export const sessionResources = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.sessionResources
);

export const sessionDetails = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.sessionDetails
);

export const coachesFilter = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.coachesFilter
);

export const sessionList = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.sessionList
);

export const participantAttendanceInfo = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.participantAttendanceInfo
);

export const markAttendance = createSelector(
  sessionsListData,
  (state: SessionsListState) => state.markAttendance
);
